import { ProductionLotStatus } from "~/gql/graphqlBase.generated";
import i18n from "~/i18n/i18n";

export const LOT_STATUS_FILTER_VALUES = [
	ProductionLotStatus.Active,
	ProductionLotStatus.Draft,
	ProductionLotStatus.Inactive
];

const LOT_STATUS_FILTER_LABEL_KEYS: Partial<Record<string, string>> = {
	[ProductionLotStatus.Active]: "schedule.lotStatus.active",
	[ProductionLotStatus.Draft]: "schedule.lotStatus.draft",
	[ProductionLotStatus.Inactive]: "schedule.lotStatus.inactive"
};

const formatLotStatusFilterLabel = (value: string | null | undefined): string => {
	const labelKey = value ? LOT_STATUS_FILTER_LABEL_KEYS[value] : undefined;
	return labelKey ? i18n.t(labelKey, { ns: "produce" }) : "";
};

export default formatLotStatusFilterLabel;
